function SecureUserAccountService($rootScope, $state) {
    this.$state = $state;
    this.redirect = {};
}

SecureUserAccountService.prototype.setRedirect = function (redirect) {
    this.redirect = redirect;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/secure-user-account/secure-user-account-service.js
 **/